import {getProfilesPaged, getProfileAverages} from "@/services/profile.service";
import moment from "moment";
import {asLocalTime} from "@/js/shared/helper";
import {allMeasuresFromConstants} from "@/js/shared/constants";

export default {
    data() {
        return {
            totalItems: 0,
            tableSettings: {
                pageNumber: 1,
                rowsPerPage: 10,
                sortByColumn: '',
                sortAscending: false,
                searchString: '',
                graduationSearchString: 'Select Graduation Year',
                groupIds: [],
                skipAverages: false
            },
            profiles: [],
            loading: true,
            loadingAverages: false,
            initialLoading: false,
            options: {},
            sortBy: [],
            typingTimer: null,
            receivedFirstProfilesSet: false,
            requestNum: 0
        }
    },
    async mounted () {
        
        // await this.updateOptions('mounted');
        // this.initialLoading = false;
        // if (this.totalItems === 0) {
        //     this.$emit('setOrgHasZeroProfiles')
        // }
        //
        // this.$emit('finishedInitialLoading')

    },
    computed: {
        isViewingAsSuper(){
            return this.$store.getters.viewingAsSuper;
        },
    },
    methods: {
        onRowClick(profile) {
            this.$router.push(`/profiles/${profile.id}/overview`)
        },

        updateSearchString(event) {
            clearTimeout(this.typingTimer);
            this.typingTimer = setTimeout(() => {
                this.tableSettings.pageNumber = 1;
                this.updateOptions()
                // alert('stopped typing')
            }, 300)
        },
        async updateOptions(options) {
            //mounted is not called before this because these mixin things petti uses are weird af
            //this is for initial load, setting to query param values
            if (this.requestNum === 0){
                this.options.page = parseInt(this.$route.query.PageNumber ?? '') || 1;
                this.tableSettings.pageNumber = parseInt(this.$route.query.PageNumber ?? '') || 1;
                this.options.itemsPerPage = parseInt(this.$route.query.RowsPerPage ?? '') || 10;
                this.tableSettings.rowsPerPage = this.options.itemsPerPage;
                // Vuetify 3: sortBy is array of { key, order } objects
                const sortColumn = this.$route.query.SortByColumn ?? '';
                const sortAsc = this.$route.query.SortAscending === 'true';
                if (sortColumn) {
                    this.sortBy = [{ key: sortColumn, order: sortAsc ? 'asc' : 'desc' }];
                }
                this.tableSettings.searchString = this.$route.query.SearchString ?? '';
                this.tableSettings.graduationSearchString = this.$route.query.graduationSearchString ?? 'Select Graduation Year';
                this.tableSettings.groupIds = this.$route.query.groupIds ?? [];
            }

            // Vuetify 3 passes the updated pagination state here — sync it into
            // both `this.options` and `tableSettings` so subsequent calls honor it.
            if (options && typeof options === 'object') {
                if (options.page != null) {
                    this.options.page = options.page;
                    this.tableSettings.pageNumber = options.page;
                }
                if (options.itemsPerPage != null) {
                    this.options.itemsPerPage = options.itemsPerPage;
                    this.tableSettings.rowsPerPage = options.itemsPerPage;
                }
                if (Array.isArray(options.sortBy)) {
                    this.sortBy = options.sortBy;
                }
            }

            let {page, itemsPerPage} = this.options;
            let sortBy = this.sortBy || [];
            if (itemsPerPage < 0) itemsPerPage = 99999999;

            // Vuetify 3: sortBy is array of { key, order } objects
            const sortColumn = sortBy.length > 0 ? sortBy[0].key : null;
            const sortAscending = sortBy.length > 0 ? sortBy[0].order === 'asc' : false;

            this.requestNum++;
            const thisRequestNum = this.requestNum;

            if (this.groupId)
                this.tableSettings.groupIds = [this.groupId];

            let request = {
                PageNumber: page,
                RowsPerPage: itemsPerPage,
                SortByColumn: sortColumn,
                SortAscending: sortAscending,
                SearchString: this.tableSettings.searchString,
                graduationSearchString: this.tableSettings.graduationSearchString,
                groupIds: this.tableSettings.groupIds,
                openEventsOnly: this.openEventsOnly,
            }
            
            this.$router.push({path: this.$route.path, query: {...request}})
            
            console.log('REQUEST: ', request);
            this.loading = true;
            // Set loadingAverages early so spinner shows while profiles load
            const isSkip = this.tableSettings && this.tableSettings.skipAverages;
            if (!isSkip) {
                this.loadingAverages = true;
            }
            let {profiles, totalRowCount} = await getProfilesPaged(request)
            this.$emit('setTotalRowCount', totalRowCount)

            let profileIds = profiles.map(x => x.id);
            
            if (this.requestNum == thisRequestNum) // avoid async errors, only update data is this is the latest response
                this.setProfiles({profiles})
            
            // this.profiles = [];
            // totalRowCount = 0

            if (this.profiles.length < 1) {
                this.$emit('setIsEmpty', true)
            } else {
                this.$emit('setIsEmpty', false)
            }

            this.totalItems = parseInt(totalRowCount) || 0;
            this.loading = false;

            this.initialLoading = false;

            if (!this.receivedFirstProfilesSet) {
                this.receivedFirstProfilesSet = true;
                if (this.totalItems === 0) {
                    this.$emit('setOrgHasZeroProfiles')
                }

                this.$emit('finishedInitialLoading')
            }

            // Fire-and-forget: averages can be expensive, so don't gate the rest of
            // the page on it. The table renders without averages, then they stream in
            // when the request resolves. requestNum guards against stale responses.
            if (!isSkip) {
                getProfileAverages(profileIds).then(averagesResponse => {
                    if (this.requestNum == thisRequestNum)
                        this.setProfiles({profiles, averages: averagesResponse.averages})
                });
            }

            return
        },
        setProfiles({profiles, averages = null}) {
            this.profiles = profiles.map(x => {
                let {id, firstName, lastName, graduationYear, lastTestDate, inActiveGroup, inEvent} = x;

                console.log('isViewingAsSuper', this.isViewingAsSuper)
                
                //variable for fullname that uses ID if viewing as super, otherwise uses first and last name
                let fullName = this.isViewingAsSuper ? id : `${firstName} ${lastName}`;
                
                //variables for firstname and lastname that is blank string if viewing as super, otherwise uses first and last name
                firstName = this.isViewingAsSuper ? '' : firstName;
                lastName = this.isViewingAsSuper ? '' : lastName;
                
                let sortedAverages = [];
                if (averages && averages[id] && averages[id].allAverages){

                    let resultsArray = [];
                    for (let measureIndex in averages[id].allAverages)
                    {
                        let measure = averages[id].allAverages[measureIndex];
                        let measureConstant = allMeasuresFromConstants[measureIndex];
                        
                        resultsArray.push({...measure, measureId: measureIndex, additionalOrder: measureConstant?.additionalOrder});
                    }
                    let resultsSorted = resultsArray.sort((a, b) => ((b.additionalOrder ?? 0)*100000 - parseInt(b.measureId)) - ((a.additionalOrder ?? 0)*100000 - parseInt(a.measureId)));
                    sortedAverages = resultsSorted;
                }
                
                return {
                    id,
                    firstName,
                    lastName,
                    graduationYear: graduationYear > 1950 ? graduationYear : null,
                    lastTestDate: lastTestDate ? asLocalTime(moment.utc(lastTestDate)).format('LLL z') : null,
                    inActiveGroup,
                    fullName: fullName,
                    averages: averages && averages[id] ? averages[id].allAverages : null, // probably unused
                    sortedAverages: sortedAverages.length > 0 ? sortedAverages : null,
                    inEvent
                }
            });
            if (averages) this.loadingAverages = false
        }

    },

}